import React, { FC } from 'react';
import { ProjectDatesFieldsProps } from './ProjectDatesFieldsProps';
import { Stack } from '@mui/material';
import CustomDateInput from '../../CustomDateInput';
import { useFormContext } from 'react-hook-form';
import Text from '@ingka/text';
import Divider from '../../Divider';
import useTranslation from '../../../hooks/useTranslation';
const ProjectDatesFields: FC<ProjectDatesFieldsProps> = ({
  initialDates,
  projectClosingDate,
  openingDate,
  establishmentTypeClose,
  closeLabel,
  isep,
}) => {
  const t = useTranslation();
  const { setValue } = useFormContext();

  const startDateChanged = (value: Date | null) => {
    if (value && !isep) {
      setValue('projectStartDate', value);
    }
  };
  const openingDateChanged = (value: Date | null) => {
    if (value && !isep) {
      setValue('projectCompletionDate', value);
    }
  };
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectDates')}
      </Text>
      <Stack direction={'row'} spacing={2}>
        <CustomDateInput
          label={'projects.properties.projectStartDate'}
          name={'targetProjectStartDate'}
          dataTestID={'project-start-date'}
          customOnChange={startDateChanged}
          required
        />
        {openingDate && (
          <CustomDateInput
            label={
              closeLabel
                ? 'labels.projectCloseDate'
                : 'labels.projectOpeningDate'
            }
            name={'targetProjectEndDate'}
            dataTestID={'project-opening-date'}
            customOnChange={openingDateChanged}
            required
          />
        )}
      </Stack>
      {initialDates && (
        <Stack direction={'row'} spacing={2}>
          <CustomDateInput
            label={'labels.initialProjectStartDate'}
            name={'projectStartDate'}
            dataTestID={'project-initial-start-date'}
            disabled
          />
          <CustomDateInput
            label={'labels.initialOpeningDate'}
            name={'projectCompletionDate'}
            dataTestID={'project-initial-opening-date'}
            disabled
          />
        </Stack>
      )}
      {projectClosingDate && (
        <CustomDateInput
          label={'labels.projectClosingDate'}
          name={'projectClosingDate'}
          dataTestID={'project-closing-date'}
        />
      )}
      {establishmentTypeClose && (
        <Stack direction={'column'} spacing={2}>
          <Stack direction={'row'} spacing={2}>
            <CustomDateInput
              label={'labels.handoverToLandlordDate'}
              name={'handoverToLandlordDate'}
              dataTestID={'project-handover-to-landlord-date'}
            />
            <CustomDateInput
              label={'labels.finalDeedDate'}
              name={'finalDeedDate'}
              dataTestID={'project-final-deed-date'}
            />
          </Stack>
          <Divider />
          <Text textStyle="Heading.S" tagName="h4">
            {t('labels.plannedAnnouncementDate')}
          </Text>
          <Stack direction={'row'} spacing={2}>
            <CustomDateInput
              label={'labels.internalAnnouncementDate'}
              name={'internalAnnouncementDate'}
              dataTestID={'project-iternal-announcement-date'}
            />
            <CustomDateInput
              label={'labels.externalAnnouncementDate'}
              name={'externalAnnouncementDate'}
              dataTestID={'project-external-announcement-date'}
            />
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default ProjectDatesFields;
